/** @format */

import React from 'react';
import PostBlock from 'components/PostBlock';
import './styles.scss';

export default function Intro(props) {
  const { tprop } = props;
  return (
    <div className='homepage-intro-container'>
      <PostBlock
        buttons={tprop.buttons}
        heading={tprop.heading}
        description={tprop.description}
        imageClassNames={'image-homepage image-homepage-1'}
      />
    </div>
  );
}
